import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'
import { useFormContext } from 'react-hook-form'

import { sortAlphabeticallyByKey } from '@fortem-monorepo/js-utilities'
import { useApi } from '@fortem-monorepo/react-spa'
import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface IssuerNameSelectFormFieldProps {}

export const IssuerNameSelectFormField: React.FC<IssuerNameSelectFormFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ issuer_name: string }>()

  const api = useApi()

  const issuerData = useQuery({
    queryKey: ['misc', 'issuers'],
    queryFn: () => api.misc.getIssuers(),
  })

  const issuerOptions = useMemo(() => {
    return sortAlphabeticallyByKey(
      (issuerData.data ?? []).map((i) => ({
        label: i.issuer_name,
        value: i.issuer_name,
      })),
      'label',
    )
  }, [issuerData.data])

  return (
    <FormField
      name="issuer_name"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Issuer Name</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              loading={issuerData.isFetching}
              value={value?.toString()}
              className={'flex flex-1 min-w-auto!'}
              placeholder={'Select an issuer'}
              setValue={(value) => setValue('issuer_name', value, { shouldValidate: true })}
              options={issuerOptions}
            />
          </FormItem>
        )
      }}
    />
  )
}
